import { faqs, howItWorks } from "./helpers";
import {
  DefaultCheckoutTerms,
  DefaultRegistrationTerms,
} from "../../default_terms_and_conditions";

import { routes } from "@/global/routes";
import { vendorUUIDs } from "../../constants";

import type { TeamConfig } from "../types";

import FindGamesBanner from "public/images/sacramentokings_flex/kings_banner.png";
import AuthBackgroundBanner from "public/images/sacramentokings_flex/kings_banner.png";
import SeatMap3dPreviewImage from "public/images/sacramentokings_flex/sacramento_kings_cover.jpeg";

const LogoImage =
  "https://ss-leagues.s3.amazonaws.com/NCAA/Kings-Primary-Color_Logo.png";

const config: TeamConfig = {
  teamSchema: "sackings_flexbank",
  browserTitle: "Sacramento Kings Flex Bank",
  packages: false,
  teamName: "Sacramento Kings",

  manageCard: true,

  // gift cards
  giftCardConfigs: {
    isMenuGiftCardEnabled: false,
    isLandingPageGiftCardEnabled: false,
    isStandalonePageGiftCardEnabled: false,
    redirectGiftCardUrl: routes.giftCard,
    hideRedeemItem: true,
    hideRecipient: true,
  },

  // disabled routes
  disabledRoutes: [],

  defaultRoute: routes.purchaseSeats,
  phoneNumber: "",

  // seat map configs
  seatMapConfigs: {
    venueId: "nam-us-00073-kings-sec",
    mapId: "main",
  },

  checkoutCreditPackages: false,
  availableCreditEnabled: true,
  isCrowdHandlerEnabled: true,
  inventoryType: "SEAT-LEVEL",

  // purchase seats config
  purchaseSeatConfigs: {
    minGameSelectionCount: 1,
    minSeatLimit: 1,
    isSimilarSeatForAllEvents: true,
    isCheckoutEditSeatsEnabled: true,
    showFrontendTotalAmount: true,
    isDiffSeatAlertEnabled: true,
    showFrontendServiceFee: true,
    allowManualCartInSimilar: true,
    checkoutTimerEnabled: false,
    isPerksEnabled: false,
    defaultSeatCount: 2,
  },

  // feature configs
  packageConfigs: {
    isPackageEnabled: false,
    canRemovePackageGames: false,
    staticBuildYourOwn: null,
  },

  // intercom settings
  intercomConfigs: {
    isIntercomEnabled: true,
    allowedPages: [],
  },

  // purchase credit configs
  purchaseCreditConfigs: {
    isLandingPurchaseCreditEnabled: true,
    isStandAlonePurchaseCreditEnabled: true,
    showPurchaseCreditLinkInHomeMenu: true,
    isPurchaseCreditHistoryEnabled: true,
    checkoutTimerEnabled: true,
  },

  // checkout validations
  checkoutValidation: {
    allowedZipFailCount: Infinity,
    allowedPaymentFailCount: Infinity,
  },

  isSaveCardAllowed: true,

  isBrainTreePaymentEnabled: false,

  // analytics configs
  analyticsConfigs: {
    googleAnalyticsId: "",
    attrkPixelId: "",
    beaconId: "",
    metaPixelId: "1846888515544840",
  },

  // call refresh inventory when selecting games
  refreshInventoryWhenEventClick: false,

  // redirect configs
  redirectConfigs: {
    internalRedirectUrl: "",
    externalRedirectUrl: "",
  },

  // urls
  accountManagerUrl: "https://am.ticketmaster.com/sackings/",

  // vendor
  platform: vendorUUIDs.ticketmaster,

  // okta config
  oktaIssuer: "",
  oktaClientId: "",

  images: {
    findGamesBannerImage: FindGamesBanner.src,
    authBackgroundImage: AuthBackgroundBanner.src,
    checkoutStatusPageImage: AuthBackgroundBanner.src,
    giftCardStandalonePageImage: AuthBackgroundBanner.src,
    logoImage: LogoImage + "?width=84&height=66",
    logoNameImage: "",
    faviconImage: LogoImage,
    seatMap3dPreviewImage: SeatMap3dPreviewImage.src,
  },

  colors: {
    primary: "#5b2c81",
  },

  howItWorks,
  faqs,

  uiConfigs: {
    bannerImage: {
      title: "",
      isBackgroundBasedBanner: false,
    },
    featuredGameCard: {
      showLogoWithTitle: false,
      hideOverlayLogo: false,
    },

    bottomBar: {
      showGameSelectionProgress: true,
    },

    hideCheckoutCartBalance: false,

    checkoutStatusPage: {
      checkoutSuccessMessageFontSize: "16px",
      checkoutSuccessMessageFontWeight: "normal",
    },

    purchaseCredit: {
      hideSecondaryTitle: true,
      purchaseCreditTitle: "Kings Flex Plans",
    },
  },

  languages: {
    topNavMenuItems: <></>,
    checkoutTermsAndCondition: <DefaultCheckoutTerms />,
    registrationTermsAndCondition: <DefaultRegistrationTerms />,
    purchaseGiftCard: null,
    redeemGiftCard: null,
    purchaseSeats: null,
    purchaseCredit: {
      mainCardDescription:
        "Purchase a Kings Flex Plan to choose the games you want, when you want! Start by selecting the amount for your flex bank: the more you purchase, the more you save! Then select your games and seats, and redeem your credit throughout the season with no added fees. Plus, you can reload your account balance at any time.",
    },

    checkoutSuccessMessage: "Your purchase is complete!",
    checkoutSuccessDescription:
      "Tickets are now available to view in your Kings ClickTix account.",

    giftCard: {
      title: "",
      createGiftCard: {
        description: "",
        recipient: {
          sendNowFalse: {
            description: "",
          },
          sendNowTrue: {
            description: "",
          },
        },
      },
      redeemGiftCard: {
        loggedIn: {
          description: "",
        },
        logout: {
          description: "",
        },
        success: {
          description: "",
        },
      },
    },

    signInAuthText:
      "Connect your Ticketmaster account to continue with seamless access.",
  },
};

export default config;
